import { render, staticRenderFns } from "./InstrumentsWind.vue?vue&type=template&id=136311e0"
import script from "./InstrumentsWind.vue?vue&type=script&lang=js"
export * from "./InstrumentsWind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports